<template>
  <selected-value v-bind="$attrs" class="selected-value me-1" :class="cssClasses" @remove-item="removeItem" />
</template>

<script>
import SelectedValue from './selected-value'

export default {
  components: { SelectedValue },

  props: {
    displayVariety: {
      // 'accent' or 'inverted-accent'
      type: String,
      required: false,
      default: 'accent'
    }
  },

  emits: ['remove-item'],

  computed: {
    cssClasses() {
      if (this.displayVariety === 'inverted-accent') {
        return ['text-primary','inverted-accent', 'bg-white']
      }
      else {
        return ['bg-primary', 'text-white']
      }
    }
  },

  methods: {
    removeItem(value) {
      this.$emit('remove-item', value)
    }
  }
}
</script>


<style lang="scss" scoped>
  @use "~mixins/rtl_only" as rtl_override;

  .selected-value {
    border-radius: 10px;
    padding: 2px 5px 2px 9px;
    font-size: small;

    @include rtl_override.rtl-only {
      padding-left: 5px;
      padding-right: 9px;
    }
  }

  .inverted-accent {
    opacity: 0.7;
  }
</style>
